import { Grid } from '@mui/material';
import { Autosuggest, SwitchInput, TextInput } from 'components';
import { format } from 'date-fns';
import { TIMEZONES_ALL } from 'lib/constants/timezones';

const AcademyEventForm = ({
	event,
	handleChange,
	academies,
	timezones = []
}) => {
	return (
		<>
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<TextInput
						name="name"
						label="Event Name"
						fullWidth
						value={event.name}
						onChange={handleChange}
						maxLength={30}
					/>
				</Grid>
				<Grid item xs={12}>
					<TextInput
						name="description"
						label="Event Description"
						multiline
						rows={3}
						fullWidth
						value={event.description}
						onChange={handleChange}
						maxLength={120}
					/>
				</Grid>
				<Grid item xs={4}>
					<Autosuggest
						options={timezones}
						label="Select Timezone"
						name="timezone"
						value={event.timezone}
						handleChange={handleChange}
						placeholder="Select a timezone"
					/>
				</Grid>
				<Grid item xs={4}>
					<TextInput
						name="start_date"
						label="Start Date"
						type="datetime-local"
						fullWidth
						required
						value={event.start_date}
						onChange={handleChange}
						InputLabelProps={{ shrink: true }}
						min={format(new Date(Date.now()), "yyyy-MM-dd'T'HH:mm")}
					/>
				</Grid>
				<Grid item xs={4}>
					<TextInput
						name="end_date"
						label="End Date"
						type="datetime-local"
						fullWidth
						value={event.end_date}
						required
						onChange={handleChange}
						disabled={!event.start_date}
						InputLabelProps={{ shrink: true }}
						min={format(event?.start_date ?? new Date(), "yyyy-MM-dd'T'HH:mm")}
					/>
				</Grid>
				<Grid item xs={6}>
					<Autosuggest
						options={academies.map((item) => ({
							label: item.title,
							value: item.id
						}))}
						label="Academy"
						name="academy_id"
						value={event.academy_id}
						handleChange={handleChange}
						placeholder="Select an academy"
					/>
				</Grid>

				<Grid
					item
					xs={3}
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<SwitchInput
						value={event.published ? true : false}
						label="Published"
						name="published"
						placeholder="Published"
						handleChange={handleChange}
					/>
				</Grid>
			</Grid>
		</>
	);
};

export default AcademyEventForm;
